import React, { useContext, useEffect, useRef, useState } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
// import Topbar from "./components/theme/global/Topbar";

import Sidebar from './components/global/Sidebar';
import Dashboard from "./environments/warehouse/dashboard";


import AuthLayout from "./environments/global/AuthLayout";
import Forgotpassword from "./environments/global/ForgotPassword";
import Login from "./environments/global/Login";
import Logout from "./environments/global/Logout";
import AccountBlocked from "./environments/global/AccountBlocked";
import ResetPassword from "./environments/global/ResetPassword";
import ShopifySetup from "./environments/global/ShopifySetup";
import AmazonSetup from "./environments/global/AmazonSetup";

// import { RequireAuth } from "react-auth-kit";
import { Box, useTheme } from "@mui/material";
import { MenuStateContext } from "./contexts/MenuState";
import { tokens } from "./theme";

// import cx from classNames
import cx from "classnames";
import SHTransition from "./components/theme/SHTransition";
import StockLocation from "./environments/warehouse/stock/locations/Index";
import StockProduct from "./environments/warehouse/stock/products/Index";
import StockManagement from "./environments/warehouse/stock/stock/Index";
import StockReplenish from "./environments/warehouse/stock/replenish/Index";
import StockRepacking from "./environments/warehouse/stock/repacking/Index";

//Outbound
import OutboundBatches from "./environments/warehouse/outbound/batches/index";
import OutboundDashboard from "./environments/warehouse/outbound/dashboard";
import OutboundOrders from "./environments/warehouse/outbound/orders/index";
import OutboundShipmentsPage from "./environments/warehouse/outbound/shipments/index";

//Reports
import Daytotals from "./environments/warehouse/reports/daytotals/Daytotals";

// Automation
import AutomationWorkflows from "./environments/warehouse/automation/workflows/index";
import AutomationCountingStrategies from "./environments/warehouse/stock/countingstrategies";

// Warehouse Relation
import WarehouseRelation from "./environments/warehouse/relation";

// Financial
import FinancialInvoiceComponents from "./environments/warehouse/financial/components";
import FinancialInvoices from "./environments/warehouse/financial/invoices/index";

// Outbound setting
import OutBoundSettingsCarriers from "./environments/warehouse/settings/warehouse/outbound/carriers/Carriers";
import OutBoundSettingsPicking from "./environments/warehouse/settings/warehouse/outbound/picking/Picking";
import OutboundSettingsStock from "./environments/warehouse/settings/warehouse/outbound/stock/Stock";
import OutBoundSettingsStreams from "./environments/warehouse/settings/warehouse/picking/streams/Streams";

//Settings
import SettingsWebshop from "./environments/warehouse/settings/integrations/webshop/Index";
import SettingsGeneral from "./environments/warehouse/settings/warehouse/general/General";
import Shippers from "./environments/warehouse/settings/warehouse/shippers/Shippers";

// Financial
import SettingsAccountingSoftware from "./environments/warehouse/settings/integrations/accountingsoftware";

//Inbound
import InboundDashboard from "./environments/warehouse/inbound/dashboard/index";
import InboundInbounds from "./environments/warehouse/inbound/inbounds/index";

// Returns
import WarehouseReturns from "./environments/warehouse/returns/index";

// Relation
import RelationDashboard from "./environments/relation/dashboard";
import RelationFinancialInvoices from "./environments/relation/financial/invoices";
import RelationSettingsIntegrator from "./environments/relation/integrations/integrator/Index";
import RelationSettingsWebshop from "./environments/relation/integrations/webshop/Index";
import RelationSettingsExternalChannels from "./environments/relation/integrations/externalchannels/Index";
import RelationApiConnections from "./environments/relation/integrations/apiconnections/Index";

import Echeck from "./environments/warehouse/echeck2/index";

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import MConfirmSaveTableSettings from "./components/global/Modals/MConfirmSaveTableSettings";

import { RequireAuth } from "./authentication/RequireAuth";
import Topbar from "./components/global/Topbar/Topbar";
import MNewsCarousel from "./components/global/Modals/MCreateNewsArticle/MNewsCarousel";
import SidepanelDeepLinkHost from "./components/global/Sidepanels/popout/SidepanelDeepLinkHost";
// import { AxiosBackendWrapper, AxiosWrapper } from "./api/Settings";
import { useDispatch, useSelector } from "react-redux";
import RelationInbound from "./environments/relation/inbounds";
import RelationPurchaseAdvice from "./environments/relation/purchaseadvice";
import RelationOutbound from "./environments/relation/orders";
import RelationStockhubBiNeverSold from "./environments/relation/reports/neversold";
import RelationStockhubBiOrdersOverview from "./environments/relation/reports/ordersoverview";
import RelationShipments from "./environments/relation/shipments";
import RelationProducts from "./environments/relation/products/Index";
import SettingsSupplier from "./environments/relation/settings/supplier/Index";
import SettingsAddresses from "./environments/relation/settings/addresses/Index";
import AccountGeneral from "./environments/user/account/General";
import UserEnvironments from "./environments/user/environments/Environments";
import Usergroups from "./environments/warehouse/settings/access/usergroups/Usergroups";
import Users from "./environments/warehouse/settings/access/users/Users";
import Whitelist from "./environments/warehouse/settings/access/whitelist/Whitelists";
import Openapikeys from "./environments/warehouse/settings/integrations/openapi/Openapikeys";
import ReturnPortalDesignWarehouse from "./environments/warehouse/settings/returnportal/ReturnPortalDesignWarehouse";
import { resetFilter } from "./newapi/global/filter/gridFilterSlice";
import { UserPrivileges } from './utils/permissions';

import SettingsReasons from "./environments/warehouse/settings/customfields/reasons/Index";
import SettingsCustomFieldsProducts from "./environments/warehouse/settings/customfields/products/Index";
import SettingsCountingStrategies from "./environments/warehouse/settings/warehouse/countingstrategies/CountingStrategies";
import Printers from "./environments/warehouse/settings/warehouse/office/printers/Printers";
import Workspaces from "./environments/warehouse/settings/warehouse/office/workspaces/Workspaces";
import Resources from "./environments/warehouse/settings/warehouse/picking/resources/Resources";
import Warehouses from "./environments/warehouse/settings/warehouse/warehouses/Warehouses";
import SettingsWorkflowTemplates from "./environments/warehouse/settings/warehouse/workflowtemplates/WorkflowTemplates";

import RelationUsergroups from "./environments/relation/access/usergroups/Usergroups";
import RelationUsers from "./environments/relation/access/users/Users";
import RelationReturns from "./environments/relation/returns";
import SettingsIntegrator from "./environments/warehouse/settings/integrations/integrator/Index";
import SettingsExternalChannels from "./environments/warehouse/settings/integrations/externalchannels/Index";
import { toggleMenu, updateMenuState } from "./newapi/global/settingsSlice";
import { TopbarProvider } from "./contexts/TopbarProvider";
import ProcessInbound from "./environments/warehouse/processinbound";
import ProcessReturns from "./environments/warehouse/processreturns";
import RelationSettingsDetails from "./environments/relation/settings/details/General";
import RelationData from "./environments/warehouse/relation/data";
import WebshopCredentialsData from "./environments/warehouse/webshopcredentials/data";
import UpdateNotification from "./components/UpdateNotification";
import useServiceWorkerUpdate from "./hooks/useServiceWorkerUpdate";
import InstallPromptModal from "./components/InstallPromptModal";
import FeedbackWidget from "./components/feedback/FeedbackWidget";
import useInstallPrompt from "./hooks/useInstallPrompt";
import { AnimatePresence, motion } from "framer-motion";
import NotificationsView from "./environments/warehouse/notifications/Index";
import ReturnPortalDesign from "./environments/relation/settings/returnportal/ReturnPortalDesign";
import ReturnReasonsSettings from "./environments/relation/settings/returnreasons/Index";
import RelationSettingsEmail from "./environments/relation/settings/email/Index";
import WarehouseSettingsEmail from "./environments/warehouse/settings/email/Index";
import { selectUser } from "./newapi/user/authentication/authSlice";
import SetupPanel from "./environments/warehouse/settings/setup/SetupPanel";
import SettingsOnboarding from "./environments/warehouse/settings/onboarding/Onboarding";
import SettingsCustomFieldsOrders from "./environments/warehouse/settings/customfields/orders/Index";
import ReportHub from "./components/global/StockhubBI/Reporthub";
import DashboardViewer from "./components/global/StockhubBI/DashboardViewer";
import { ReportHubFilterProvider } from "./components/global/StockhubBI/ReportHubFilterContext";
import ReportDetailPageBuilder from "./components/global/StockhubBI/ReportDetailPageBuilder";
import ReportDetailPage from "./components/global/StockhubBI/ReportDetailPage";
import ReportDetailPageViewer from "./components/global/StockhubBI/ReportDetailPage";
import ErrorBoundary from "./components/global/ErrorBoundary";

// Software (SHA admin)
import SoftwareEnvironments from "./environments/software/environments/Index";
import SoftwareNews from "./environments/software/news/Index";
import SoftwareErrors from "./environments/software/errors/Index";
import SoftwareOrders from "./environments/software/orders/Index";
import SoftwareFeedback from "./environments/software/feedback/Index";
import WarehouseServideDesk from "./environments/warehouse/relation/service";
import WarehouseRelationNews from "./environments/warehouse/relation/news";
import RelationServiceDesk from "./environments/relation/service";
// import ReportDetailPageBuilder from "./components/global/StockhubBI/ReportDetailPageBuilder";
// import { ReportHubFilterProvider } from "./components/global/StockhubBI/ReportHubFilterContext";

const AppMenu = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  
  const collapsed = useSelector((state) => state.settings.environment.collapsed);

  const backdropRef = useRef(null);

  const [windowSize, setWindowSize] = useState(window.innerWidth);
  const handleResize = (event) => {
      setWindowSize(window.innerWidth);
  }

  useEffect(() => {
      setWindowSize(window.innerWidth);
      window.addEventListener("resize", handleResize);

      return () => {
          window.removeEventListener("resize", handleResize);
      }
  }, [])

  useEffect(() => {
      if(collapsed && windowSize <= 1369) {
        backdropRef.current.classList.add("menu-backdrop-enter-done");
      }
  },[collapsed,theme.palette.mode,windowSize]);

  return (
    <React.Fragment>
      <SHTransition
        className={"menu-backdrop"}
        nodeRef={backdropRef}
        in={collapsed }
        // in={true}
        classNames="menu-backdrop"
        appear
        
        timeout={500}
      >
        <Box className={`stockhub ${theme.palette.mode}`} onClick={() => dispatch(toggleMenu())} ref={backdropRef} sx={{position:"fixed", left:0,top:0,width:1,height:1,zIndex:"-1"}}></Box> 
      </SHTransition>
      
      <ToastContainer autoClose={1200} />
      <MConfirmSaveTableSettings />
      <UpdateNotification />
    </React.Fragment>
  )

}

function App() {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode)
  const location = useLocation();
  const dispatch = useDispatch();
  const isLoginPage = location.pathname.startsWith("/login") || location.pathname.startsWith("/forgot") || location.pathname.startsWith("/reset") || location.pathname === "/blocked";
  // Auth routes share a single key so the outer AnimatePresence does not
  // animate between them; the inner AuthLayout AnimatePresence handles that.
  // /blocked gets its own key so the transition from login to blocked animates.
  const pageTransitionKey = location.pathname === "/blocked" ? "/blocked" : isLoginPage ? "/auth" : location.pathname;
  const [isRmaPortal, setIsRmaPortal] = useState(window.location.hostname.includes("clicktoreturn"));
   
  const user = useSelector(selectUser);

  // index.html carries the login title for SEO; inside the app the tab just says Stockhub
  useEffect(() => {
    document.title = isLoginPage ? "Inloggen | Stockhub WMS voor fulfilment en webshops" : "Stockhub";
  }, [isLoginPage]);

  useEffect(() => {
    dispatch(resetFilter());
  },[])

  // Check for service worker updates on navigation
  useServiceWorkerUpdate();

  // PWA installation prompt
  const { isInstallable } = useInstallPrompt();
  const [showInstallModal, setShowInstallModal] = useState(false);

  // Check if user is on a global page (not logged in)
  const isGlobalPage = location.pathname.startsWith("/login") ||
                      location.pathname.startsWith("/forgot") ||
                      location.pathname.startsWith("/reset") ||
                      location.pathname === "/logout" ||
                      location.pathname === "/blocked" ||
                      location.pathname.startsWith("/setup/");

  // Show install modal after a delay when installable
  useEffect(() => {
    if (isInstallable && !isRmaPortal && !isGlobalPage) {
      // Wait a bit for the user to get familiar with the app
      const timer = setTimeout(() => {
        setShowInstallModal(true);
      }, 10000); // Show after 10 seconds

      return () => clearTimeout(timer);
    }
  }, [isInstallable, isRmaPortal, isGlobalPage]);
  const collapsed = useSelector((state) => state.settings.environment.collapsed);

  return (
    <TopbarProvider>
      <div className="app">
        {!isLoginPage && <Sidebar/>}
        {/* <MotionM */}
        <Box
          component={"main"}
          className={cx(`content`, {
            'hide-side' : isLoginPage
          })}
          sx={{
            background:theme.palette.mode === "dark" ? isLoginPage ? colors.grey[100] : colors.grey["200"] : colors.grey["0"],
            "@media screen and (max-width: 47.9375em)" : {
              overflow:collapsed ? "hidden" : "unset"
            }
          }}
        >
          {!isLoginPage && <Topbar/>}
          {!isLoginPage && <MNewsCarousel/>}
          <AnimatePresence mode="wait">
            <ErrorBoundary key={pageTransitionKey}>
              <motion.div
                key={pageTransitionKey}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{
                  duration: 0.15,
                  ease: "easeInOut"
                }}
                style={{
                  height: "100%",
                  width: "100%",
                  display:"flex",
                }}
              >
              <Routes location={location} key={pageTransitionKey}>
                <Route
                  path="/"
                  element={<Navigate to="/login" />}
                ></Route>

                <Route path="/warehouse">
                  {/* Echeck Route */}
                  <Route path="dashboard" 
                    element={
                      <RequireAuth path="/warehouse/outbound/orders" permissions={[UserPrivileges.DASHBOARD_READ]}>
                        <Dashboard />
                      </RequireAuth>
                    }
                  />
                  <Route path="notifications" 
                    element={
                      <RequireAuth path="/login" permissions={[UserPrivileges.DASHBOARD_READ]}>
                        <NotificationsView />
                      </RequireAuth>
                    }
                  />

                  {/* Outbound Routes */}
                  <Route path="outbound">
                    <Route path="dashboard" 
                      element={
                        <RequireAuth permissions={[UserPrivileges.ORDERS_PAGE_READ, UserPrivileges.OUTBOUND_READ, UserPrivileges.OUTBOUND_MANAGE]} path="/login">
                          <OutboundDashboard />
                        </RequireAuth>
                      }
                    />
                    <Route path="orders" 
                      element={
                        <RequireAuth permissions={[UserPrivileges.ORDERS_PAGE_READ,UserPrivileges.OUTBOUND_READ, UserPrivileges.OUTBOUND_MANAGE]} path="/login">
                          <OutboundOrders />
                        </RequireAuth>
                      }
                    />
                    <Route path="shipments" 
                      element={
                        <RequireAuth permissions={[UserPrivileges.ORDERS_PAGE_READ,UserPrivileges.OUTBOUND_READ, UserPrivileges.OUTBOUND_MANAGE]} path="/login">
                          <OutboundShipmentsPage />
                        </RequireAuth>
                      }
                    />
                    <Route path="batches" 
                      element={
                        <RequireAuth permissions={[UserPrivileges.BATCHES_PAGE_READ,UserPrivileges.OUTBOUND_READ, UserPrivileges.OUTBOUND_MANAGE]} path="/login">
                          <OutboundBatches />
                        </RequireAuth>
                      }
                    />
                  </Route>

                  {/* Automation Routes */}
                  <Route path="automation">
                    <Route path="workflows" 
                      element={
                        <RequireAuth permissions={[UserPrivileges.WORKFLOW_READ]} path="/login">
                          <AutomationWorkflows />
                        </RequireAuth>
                      }
                    />
                  </Route>

                  {/* Relations Routes */}
                  <Route path="relations">
                    <Route path="overview" 
                      element={
                        <RequireAuth permissions={[UserPrivileges.RELATIONS_PAGE_READ,UserPrivileges.RELATION_READ, UserPrivileges.RELATION_MANAGE]} path="/login">
                          <WarehouseRelation />
                        </RequireAuth>
                      }
                    />
                    <Route path="servicedesk"
                      element={
                        <RequireAuth permissions={[UserPrivileges.SUPPORT_READ,UserPrivileges.SUPPORT_MANAGE]} path="/login">
                          <WarehouseServideDesk/>
                        </RequireAuth>
                      }
                    />
                    <Route path="news"
                      element={
                        <RequireAuth permissions={[UserPrivileges.RELATION_MANAGE]} path="/login">
                          <WarehouseRelationNews />
                        </RequireAuth>
                      }
                    />
                    <Route path="data"
                      element={
                        <RequireAuth permissions={[UserPrivileges.RELATIONS_PAGE_READ,UserPrivileges.RELATION_READ, UserPrivileges.RELATION_MANAGE]} path="/login">
                          <RelationData />
                        </RequireAuth>
                      }
                    />
                  </Route>
                  <Route path="webshopcredentials/data"
                    element={
                      <RequireAuth permissions={[UserPrivileges.CHANNELS_PAGE_READ,UserPrivileges.WEBSHOPCREDENTIALS_MANAGE]} path="/login">
                        <WebshopCredentialsData />
                      </RequireAuth>
                    }
                  />

                  {/* Financial Routes */}
                  <Route path="financial">
                    <Route path="invoices" 
                      element={
                        <RequireAuth permissions={[UserPrivileges.INVOICE_PAGE_READ,UserPrivileges.INVOICE_READ, UserPrivileges.INVOICE_MANAGE]} path="/login">
                          <FinancialInvoices />
                        </RequireAuth>
                      }
                    />
                    <Route path="components" 
                      element={
                        <RequireAuth permissions={[UserPrivileges.INVOICEPARTS_PAGE_READ,UserPrivileges.INVOICEPRODUCT_READ, UserPrivileges.INVOICEPRODUCT_MANAGE, UserPrivileges.INVOICECATEGORY_READ, UserPrivileges.INVOICECATEGORY_MANAGE]} path="/login">
                          <FinancialInvoiceComponents />
                        </RequireAuth>
                      }
                    />
                  </Route>

                  {/* Inbound Routes */}
                  <Route path="inbound">
                    <Route path="dashboard" 
                      element={
                        <RequireAuth permissions={[UserPrivileges.INBOUNDS_PAGE_READ,UserPrivileges.INBOUND_READ, UserPrivileges.INBOUND_MANAGE]} path="/login">
                          <InboundDashboard />
                        </RequireAuth>
                      }
                    />
                    <Route path="inbounds"
                      element={
                        <RequireAuth permissions={[UserPrivileges.INBOUNDS_PAGE_READ, UserPrivileges.INBOUND_READ, UserPrivileges.INBOUND_MANAGE]} path="/login">
                          <InboundInbounds />
                        </RequireAuth>
                      }
                    />
                    <Route path="purchaseadvice"
                      element={
                        <RequireAuth permissions={[UserPrivileges.INBOUNDS_PAGE_READ, UserPrivileges.INBOUND_READ, UserPrivileges.INBOUND_MANAGE]} path="/login">
                          <RelationPurchaseAdvice />
                        </RequireAuth>
                      }
                    />
                  </Route>
                  {/* Returns Routes */}
                  <Route path="returns">
                    <Route path="" 
                      element={
                        <RequireAuth permissions={[UserPrivileges.RETURN_READ, UserPrivileges.RETURN_MANAGE]} path="/login">
                          <WarehouseReturns />
                        </RequireAuth>
                      }
                    />
                  </Route>

                  <Route path="daytotals" 
                    element={
                      <RequireAuth path="/warehouse/outbound/orders" permissions={[UserPrivileges.REPORT_READ]}>
                        <Daytotals/>
                      </RequireAuth>
                    }
                  />

                  <Route path="stockhubbi">

                    {/* Hub */}
                    <Route 
                      path="dashboard/create" 
                      element={
                        <RequireAuth path="/warehouse/outbound/orders" permissions={[UserPrivileges.REPORT_READ]}>
                          <ReportHubFilterProvider>
                            <ReportHub />
                          </ReportHubFilterProvider>
                        </RequireAuth>
                      }
                    />

                    <Route 
                      path="report/create" 
                      element={
                        <RequireAuth path="/warehouse/outbound/orders" permissions={[UserPrivileges.REPORT_READ]}>
                          <ReportHubFilterProvider>
                            <ReportDetailPageBuilder />
                          </ReportHubFilterProvider>
                        </RequireAuth>
                      }
                    />

                    {/* Dynamic Report */}
                    <Route 
                      path="report/:id" 
                      element={
                        <RequireAuth path="/warehouse/outbound/orders" permissions={[UserPrivileges.REPORT_READ]}>
                          <ReportHubFilterProvider>
                            <ReportDetailPageViewer />
                          </ReportHubFilterProvider>
                        </RequireAuth>
                      }
                    />

                    {/* Edit an existing dashboard (builder) */}
                    <Route
                      path="dashboard/:id/edit"
                      element={
                        <RequireAuth path="/warehouse/outbound/orders" permissions={[UserPrivileges.REPORT_READ]}>
                          <ReportHubFilterProvider>
                            <ReportHub />
                          </ReportHubFilterProvider>
                        </RequireAuth>
                      }
                    />

                    {/* View a rendered dashboard */}
                    <Route
                      path="dashboard/:id"
                      element={
                        <RequireAuth path="/warehouse/outbound/orders" permissions={[UserPrivileges.REPORT_READ]}>
                          <ReportHubFilterProvider>
                            <DashboardViewer />
                          </ReportHubFilterProvider>
                        </RequireAuth>
                      }
                    />

                  </Route>
                  {/* Stock Routes */}
                  <Route path="stock">
                    <Route path="stock" 
                      element={
                        <RequireAuth permissions={[UserPrivileges.STOCK_PAGE_READ, UserPrivileges.STOCK_READ, UserPrivileges.STOCK_MANAGE]} path="/login">
                          <StockManagement />
                        </RequireAuth>
                      }
                    />
                    <Route path="locations" 
                      element={
                        <RequireAuth permissions={[UserPrivileges.WAREHOUSELOCATIONS_PAGE_READ,UserPrivileges.WAREHOUSELOCATION_READ, UserPrivileges.WAREHOUSELOCATION_MANAGE]} path="/login">
                          <StockLocation />
                        </RequireAuth>
                      }
                    />
                    <Route path="products" 
                      element={
                        <RequireAuth permissions={[UserPrivileges.PRODUCTS_PAGE_READ, UserPrivileges.PRODUCT_READ, UserPrivileges.PRODUCT_MANAGE]} path="/login">
                          <StockProduct />
                        </RequireAuth>
                      }
                    />
                    <Route path="replenish" 
                      element={
                        <RequireAuth permissions={[UserPrivileges.REPLENISHLINE_READ, UserPrivileges.REPLENISHLINE_MANAGE]} path="/login">
                          <StockReplenish />
                        </RequireAuth>
                      }
                    />
                    <Route path="repackingorders" 
                      element={
                        <RequireAuth permissions={[UserPrivileges.APP, UserPrivileges.STOCK_READ]} path="/login">
                          <StockRepacking />
                        </RequireAuth>
                      }
                    />
                    
                    <Route path="countingstrategies" 
                      element={
                        <RequireAuth permissions={[UserPrivileges.COUNTINGASSIGNMENT_PAGE_READ, UserPrivileges.COUNTINGSTRATEGY_READ, UserPrivileges.COUNTINGSTRATEGY_MANAGE]} path="/login">
                          <AutomationCountingStrategies />
                        </RequireAuth>
                      }
                    />
                  </Route>


                  {/* Echeck Route */}
                  <Route path="echeck" 
                    element={
                      // <NavigationBlockingProvider>
                        <RequireAuth permissions={[UserPrivileges.ECHECK]} path="/login">
                          <Echeck />
                        </RequireAuth>
                      // </NavigationBlockingProvider>
                    }
                  />
                  <Route path="processinbound" 
                    element={
                      // <NavigationBlockingProvider>
                        <RequireAuth permissions={[UserPrivileges.INBOUNDPROCESSING_PAGE_READ, UserPrivileges.INBOUND_MANAGE]} path="/login">
                          <ProcessInbound />
                        </RequireAuth>
                      // </NavigationBlockingProvider>
                    }
                  />
                  <Route path="processreturns" 
                    element={
                      // <NavigationBlockingProvider>
                        <RequireAuth permissions={[UserPrivileges.RETURNSPROCESSING_PAGE_READ, UserPrivileges.RETURN_MANAGE]} path="/login">
                          <ProcessReturns />
                        </RequireAuth>
                      // </NavigationBlockingProvider>
                    }
                  />

                  {/* Settings */}
                  <Route
                    path="settings"
                  >
                    <Route path="outbound/carriers" 
                      element={
                        <RequireAuth
                          permissions={[UserPrivileges.CARRIER_MANAGE, UserPrivileges.SETTINGS_ALL]}
                          path="/login"
                        >
                          <OutBoundSettingsCarriers/>
                        </RequireAuth>
                      }
                    />
                    <Route path="outbound/picking" 
                      element={
                        <RequireAuth
                          path="/login"
                        >
                          <OutBoundSettingsPicking/>
                        </RequireAuth>
                      }
                    />
                    <Route path="outbound/stock" 
                      element={
                        <RequireAuth
                          path="/login"
                        >
                          <OutboundSettingsStock/>
                        </RequireAuth>
                      }
                    />
                    <Route path="general"
                      element={
                        <RequireAuth
                          permissions={[UserPrivileges.SETTINGS_GENERAL, UserPrivileges.SETTINGS_ALL]}
                          path="/login"
                        >
                          <SettingsGeneral/>
                        </RequireAuth>
                      }
                    />
                    <Route path="onboarding"
                      element={
                        <RequireAuth
                          permissions={[UserPrivileges.SETTINGS_GENERAL, UserPrivileges.SETTINGS_ALL]}
                          path="/login"
                        >
                          <SettingsOnboarding/>
                        </RequireAuth>
                      }
                    />
                    <Route path="email"
                      element={
                        <RequireAuth
                          permissions={[UserPrivileges.SETTINGS_GENERAL, UserPrivileges.SETTINGS_ALL]}
                          path="/login"
                        >
                          <WarehouseSettingsEmail/>
                        </RequireAuth>
                      }
                    />
                    <Route path="suppliers"
                      element={
                        <RequireAuth
                          permissions={[UserPrivileges.SUPPLIER_READ, UserPrivileges.SUPPLIER_MANAGE]}
                          path="/login"
                        >
                          <SettingsSupplier/>
                        </RequireAuth>
                      }
                    />
                    <Route path="shippers" 
                      element={
                        <RequireAuth
                          permissions={[UserPrivileges.SHIPPER_READ, UserPrivileges.SHIPPER_MANAGE, UserPrivileges.SETTINGS_ALL]}
                          path="/login"
                        >
                          <Shippers/>
                        </RequireAuth>
                      }
                    />
                    <Route path="warehouses" 
                      element={
                        <RequireAuth
                          permissions={[UserPrivileges.WAREHOUSE_READ, UserPrivileges.WAREHOUSE_MANAGE, UserPrivileges.SETTINGS_ALL]}
                          path="/login"
                        >
                          <Warehouses/>
                        </RequireAuth>  
                      }
                    />
                    <Route path="picking/streams" 
                      element={
                        <RequireAuth
                          permissions={[UserPrivileges.STREAM_READ, UserPrivileges.STREAM_MANAGE, UserPrivileges.SETTINGS_ALL]}
                          path="/login"
                        >
                          <OutBoundSettingsStreams/>
                        </RequireAuth>
                      }
                    />
                    <Route path="picking/resources" 
                      element={
                        <RequireAuth
                          permissions={[UserPrivileges.PICKINGRESOURCE_READ, UserPrivileges.PICKINGRESOURCE_MANAGE, UserPrivileges.SETTINGS_ALL]}
                          path="/login"
                        >
                          <Resources/>
                        </RequireAuth>
                      }
                    />

                  <Route path="customfields">
                        <Route path="products" 
                          element={
                            <RequireAuth
                              permissions={[UserPrivileges.PRODUCTFIELD_MANAGE, UserPrivileges.SETTINGS_ALL]}
                              path="/login"
                            >
                              <SettingsCustomFieldsProducts/>
                            </RequireAuth>
                          }
                        />
                        <Route path="orders" 
                      element={
                        <RequireAuth
                          permissions={[UserPrivileges.PRODUCTFIELD_MANAGE, UserPrivileges.SETTINGS_ALL]}
                          path="/login"
                        >
                          <SettingsCustomFieldsOrders/>
                        </RequireAuth>
                      }
                    />
                        <Route path="reasons" 
                      element={
                        <RequireAuth
                          permissions={[UserPrivileges.SETTINGS_ALL]}
                          path="/login"
                        >
                          <SettingsReasons/>
                        </RequireAuth>
                      }
                    />
                      </Route>

                      SettingsReasons
                      
                    <Route path="automation/countingstrategies" 
                      element={
                        <RequireAuth 
                          permissions={[UserPrivileges.COUNTINGSTRATEGYTEMPLATE_MANAGE, UserPrivileges.SETTINGS_ALL]}
                        path="/login"
                        >
                          <SettingsCountingStrategies />
                        </RequireAuth>
                      }
                    />
                    <Route path="automation/workflowtemplates" 
                      element={
                        <RequireAuth path="/login">
                          <SettingsWorkflowTemplates />
                        </RequireAuth>
                      }
                    />
                    <Route path="integrations/saleschannels" 
                      element={
                        <RequireAuth permissions={[UserPrivileges.WEBSHOPCREDENTIALS_MANAGE, UserPrivileges.SETTINGS_ALL]} path="/login">
                          <SettingsWebshop />
                        </RequireAuth>
                      }
                    />
                    <Route path="integrations/integrators"
                      element={
                        <RequireAuth permissions={[UserPrivileges.WEBSHOPCREDENTIALS_MANAGE, UserPrivileges.SETTINGS_ALL]} path="/login">
                          <SettingsIntegrator />
                        </RequireAuth>
                      }
                    />
                    <Route path="integrations/externalchannels"
                      element={
                        <RequireAuth permissions={[UserPrivileges.EXTERNALCHANNELS_MANAGE, UserPrivileges.SETTINGS_ALL]} path="/login">
                          <SettingsExternalChannels />
                        </RequireAuth>
                      }
                    />
                    <Route path="integrations/accountingsoftware" 
                      element={
                        <RequireAuth permissions={[UserPrivileges.ACCOUNTINGSOFTWARE_MANAGE, UserPrivileges.SETTINGS_ALL]} path="/login">
                          <SettingsAccountingSoftware />
                        </RequireAuth>
                      }
                    />
                    
                    <Route path="office/workspaces" 
                      element={
                        <RequireAuth permissions={[UserPrivileges.WORKSPACE_READ, UserPrivileges.WORKSPACE_MANAGE, UserPrivileges.SETTINGS_ALL]} path="/login">
                          <Workspaces />
                        </RequireAuth>
                      }
                    />
                    <Route path="office/printers" 
                      element={
                        <RequireAuth permissions={[UserPrivileges.PRINTER_READ, UserPrivileges.PRINTER_MANAGE, UserPrivileges.SETTINGS_ALL]} path="/login">
                          <Printers />
                        </RequireAuth>
                      }
                    />
                    <Route path="access/users" 
                      element={
                        <RequireAuth permissions={[UserPrivileges.SETTINGS_USERS, UserPrivileges.SETTINGS_ALL]} path="/login">
                          <Users />
                        </RequireAuth>
                      }
                    />
                    <Route path="access/usergroups" 
                      element={
                        <RequireAuth permissions={[UserPrivileges.SETTINGS_USERPRIVILEGES, UserPrivileges.SETTINGS_ALL]} path="/login">
                          <Usergroups />
                        </RequireAuth>
                      }
                    />
                    <Route path="access/whitelists"
                      element={
                        <RequireAuth permissions={[UserPrivileges.SETTINGS_WHITELISTS, UserPrivileges.SETTINGS_ALL]} path="/login">
                          <Whitelist />
                        </RequireAuth>
                      }
                    />
                    <Route path="integrations/openapi"
                      element={
                        <RequireAuth permissions={[UserPrivileges.WEBSHOPCREDENTIALS_MANAGE, UserPrivileges.SETTINGS_ALL]} path="/login">
                          <Openapikeys />
                        </RequireAuth>
                      }
                    />

                    <Route path="returnportal"
                      element={
                        <RequireAuth path="/login" 
                        permissions={[UserPrivileges.RETURN_PORTAL]}
                        >
                          <ReturnPortalDesignWarehouse />
                        </RequireAuth>
                      }
                    />
                    {user?.sha &&
                      <Route path="setup" 
                        element={
                          <RequireAuth superUser path="/login">
                            <SetupPanel />
                          </RequireAuth>
                        }
                      />
                    }
                  </Route>
                </Route>
                    
                <Route path="/relation">

                  <Route path="dashboard" 
                    element={
                      <RequireAuth path="/login">
                        <RelationDashboard />
                      </RequireAuth>
                    } 
                  />

                  <Route path="notifications" 
                    element={
                      <RequireAuth path="/login">
                        <NotificationsView />
                      </RequireAuth>
                    }
                  />
                  
                  <Route path="outbound"
                    element={
                      <RequireAuth path="/login" permissions={[UserPrivileges.RP_ORDER_READ, UserPrivileges.RP_ORDER_MANAGE]}>
                        <RelationOutbound />
                      </RequireAuth>
                    }
                  />

                  <Route path="stockhubbi/report/neversold"
                    element={
                      <RequireAuth path="/login" permissions={[UserPrivileges.RP_PRODUCT_READ, UserPrivileges.RP_PRODUCT_MANAGE]}>
                        <RelationStockhubBiNeverSold />
                      </RequireAuth>
                    }
                  />

                  {/* Pre-made, so it beats the builder's dashboard/:id below - a static segment outranks a param. */}
                  <Route path="stockhubbi/dashboard/orders"
                    element={
                      <RequireAuth path="/login" permissions={[UserPrivileges.RP_ORDER_READ, UserPrivileges.RP_ORDER_MANAGE]}>
                        <RelationStockhubBiOrdersOverview />
                      </RequireAuth>
                    }
                  />

                  {/* The same hub the warehouse runs, under the relation prefix. The filter schema drops
                      the relation dimension here, and the API rejects a config that carries one anyway. */}
                  <Route path="stockhubbi">

                    <Route
                      path="dashboard/create"
                      element={
                        <RequireAuth path="/login" permissions={[UserPrivileges.RP_PRODUCT_READ, UserPrivileges.RP_PRODUCT_MANAGE]}>
                          <ReportHubFilterProvider>
                            <ReportHub />
                          </ReportHubFilterProvider>
                        </RequireAuth>
                      }
                    />

                    <Route
                      path="report/create"
                      element={
                        <RequireAuth path="/login" permissions={[UserPrivileges.RP_PRODUCT_READ, UserPrivileges.RP_PRODUCT_MANAGE]}>
                          <ReportHubFilterProvider>
                            <ReportDetailPageBuilder />
                          </ReportHubFilterProvider>
                        </RequireAuth>
                      }
                    />

                    <Route
                      path="report/:id"
                      element={
                        <RequireAuth path="/login" permissions={[UserPrivileges.RP_PRODUCT_READ, UserPrivileges.RP_PRODUCT_MANAGE]}>
                          <ReportHubFilterProvider>
                            <ReportDetailPageViewer />
                          </ReportHubFilterProvider>
                        </RequireAuth>
                      }
                    />

                    <Route
                      path="dashboard/:id/edit"
                      element={
                        <RequireAuth path="/login" permissions={[UserPrivileges.RP_PRODUCT_READ, UserPrivileges.RP_PRODUCT_MANAGE]}>
                          <ReportHubFilterProvider>
                            <ReportHub />
                          </ReportHubFilterProvider>
                        </RequireAuth>
                      }
                    />

                    <Route
                      path="dashboard/:id"
                      element={
                        <RequireAuth path="/login" permissions={[UserPrivileges.RP_PRODUCT_READ, UserPrivileges.RP_PRODUCT_MANAGE]}>
                          <ReportHubFilterProvider>
                            <DashboardViewer />
                          </ReportHubFilterProvider>
                        </RequireAuth>
                      }
                    />

                  </Route>

                  <Route path="shipments"
                    element={
                      <RequireAuth path="/login" permissions={[UserPrivileges.RP_ORDER_READ, UserPrivileges.RP_ORDER_MANAGE]}>
                        <RelationShipments />
                      </RequireAuth>
                    } 
                  />
                  
                  <Route path="products" 
                    element={
                      <RequireAuth path="/login" permissions={[UserPrivileges.RP_PRODUCT_READ, UserPrivileges.RP_PRODUCT_MANAGE]}>
                        <RelationProducts />
                      </RequireAuth>
                    } 
                  />
                  <Route path="inbound"
                    element={
                      <RequireAuth path="/login" permissions={[UserPrivileges.RP_INBOUND_READ, UserPrivileges.RP_INBOUND_MANAGE]}>
                        <RelationInbound />
                      </RequireAuth>
                    }
                  />
                  <Route path="purchaseadvice"
                    element={
                      <RequireAuth path="/login" permissions={[UserPrivileges.RP_INBOUND_READ, UserPrivileges.RP_INBOUND_MANAGE]}>
                        <RelationPurchaseAdvice />
                      </RequireAuth>
                    }
                  />
                  <Route path="returns"
                    element={
                      <RequireAuth path="/login" permissions={[UserPrivileges.RP_RETURN_READ, UserPrivileges.RP_RETURN_MANAGE]}>
                        <RelationReturns />
                      </RequireAuth>
                    } 
                  />

                  <Route path="financial/invoices"
                    element={
                      <RequireAuth path="/login" permissions={[UserPrivileges.RP_INVOICE_READ]}>
                        <RelationFinancialInvoices />
                      </RequireAuth>
                    }
                  />
                  <Route path="servicedesk"
                    element={
                      <RequireAuth path="/login" permissions={[UserPrivileges.RP_SUPPORT_READ, UserPrivileges.RP_SUPPORT_MANAGE]}>
                        <RelationServiceDesk />
                      </RequireAuth>
                    }
                  />
                  <Route path="settings">
                  
                    <Route path="access/users" 
                      element={
                        <RequireAuth path="/login" permissions={[UserPrivileges.RP_ACCESS_READ, UserPrivileges.RP_ACCESS_MANAGE]}>
                          <RelationUsers />
                        </RequireAuth>
                      } 
                    />
                    <Route path="returnportal"
                      element={
                        <RequireAuth path="/login" permissions={[UserPrivileges.RP_RETURN_PORTAL]}>
                          <ReturnPortalDesign />
                        </RequireAuth>
                      }
                    />
                    <Route path="returnreasons"
                      element={
                        <RequireAuth path="/login" permissions={[UserPrivileges.RP_RETURN_MANAGE]}>
                          <ReturnReasonsSettings />
                        </RequireAuth>
                      }
                    />
                    <Route path="access/usergroups" 
                      element={
                        <RequireAuth path="/login" permissions={[UserPrivileges.RP_ACCESS_READ, UserPrivileges.RP_ACCESS_MANAGE]}>
                          <RelationUsergroups />
                        </RequireAuth>
                      } 
                    />
                    <Route path="suppliers"
                      element={
                        <RequireAuth path="/login" permissions={[UserPrivileges.RP_SUPPLIER_READ, UserPrivileges.RP_SUPPLIER_MANAGE]}>
                          <SettingsSupplier />
                        </RequireAuth>
                      }
                    />

                    <Route path="addresses"
                      element={
                        <RequireAuth path="/login" permissions={[UserPrivileges.RP_ORDER_READ, UserPrivileges.RP_ORDER_MANAGE]}>
                          <SettingsAddresses />
                        </RequireAuth>
                      }
                    />

                    <Route path="details"
                      element={
                        <RequireAuth path="/login" permissions={[UserPrivileges.RP_ACCESS_READ, UserPrivileges.RP_ACCESS_MANAGE]}>
                          <RelationSettingsDetails />
                        </RequireAuth>
                      }
                    />

                    <Route path="email"
                      element={
                        <RequireAuth path="/login" permissions={[UserPrivileges.RP_COMPANY_INFO_READ, UserPrivileges.RP_COMPANY_INFO_MANAGE]}>
                          <RelationSettingsEmail />
                        </RequireAuth>
                      }
                    />

                  </Route>
                  <Route path="integrations">
                    <Route path="saleschannels" 
                        element={
                          <RequireAuth path="/login" permissions={[UserPrivileges.RP_WEBSHOPCREDENTIALS_MANAGE]}>
                            <RelationSettingsWebshop />
                          </RequireAuth>
                        }
                    />
                    <Route path="integrators"
                      element={
                        <RequireAuth path="/login" permissions={[UserPrivileges.RP_WEBSHOPCREDENTIALS_MANAGE]}>
                          <RelationSettingsIntegrator />
                        </RequireAuth>
                      }
                    />
                    <Route path="externalchannels"
                      element={
                        <RequireAuth path="/login" permissions={[UserPrivileges.RP_EXTERNALCHANNELS_MANAGE]}>
                          <RelationSettingsExternalChannels />
                        </RequireAuth>
                      }
                    />
                    <Route path="apiconnections"
                      element={
                        <RequireAuth path="/login" permissions={[UserPrivileges.RP_WEBSHOPCREDENTIALS_MANAGE]}>
                          <RelationApiConnections />
                        </RequireAuth>
                      }
                    />
                  </Route>
                </Route>

                {/* Software (SHA admin) */}
                <Route path="/software">
                    <Route path="environments"
                        element={
                            <RequireAuth superUser path="/login">
                                <SoftwareEnvironments />
                            </RequireAuth>
                        }
                    />
                    <Route path="news"
                        element={
                            <RequireAuth superUser path="/login">
                                <SoftwareNews />
                            </RequireAuth>
                        }
                    />
                    <Route path="errors"
                        element={
                            <RequireAuth superUser path="/login">
                                <SoftwareErrors />
                            </RequireAuth>
                        }
                    />
                    <Route path="orders"
                        element={
                            <RequireAuth superUser path="/login">
                                <SoftwareOrders />
                            </RequireAuth>
                        }
                    />
                    <Route path="feedback"
                        element={
                            <RequireAuth superUser path="/login">
                                <SoftwareFeedback />
                            </RequireAuth>
                        }
                    />
                </Route>

                    <Route
                      path="/user"
                    >
                      <Route path="account/general" element={
                          <RequireAuth
                            path="/login"
                          >
                            <AccountGeneral/>
                          </RequireAuth>
                        }
                      />
                      <Route path="environments" element={
                          <RequireAuth
                            path="/login"
                          >
                            <UserEnvironments/>
                          </RequireAuth>
                        }
                      />

                    </Route>
                
                
                <Route
                  path="/*"
                  element={<Navigate to="/login" />}
                ></Route>

                <Route path="/logout" element={<Logout/>}></Route>
                <Route path="/blocked" element={<AccountBlocked/>}></Route>
                <Route element={<AuthLayout/>}>
                  <Route path="/login" element={<Login/>}></Route>
                  <Route path="/login/:brandSlug" element={<Login/>}></Route>
                  <Route path="/forgot" element={<Forgotpassword/>}></Route>
                  <Route path="/forgot/:brandSlug" element={<Forgotpassword/>}></Route>
                  <Route path="/reset" element={<ResetPassword/>}></Route>
                  <Route path="/reset/:brandSlug" element={<ResetPassword/>}></Route>
                </Route>
                <Route path="/setup/shopify" element={<ShopifySetup/>}></Route>
                <Route path="/setup/amazon" element={<AmazonSetup/>}></Route>
              </Routes>
            </motion.div>
            </ErrorBoundary>

            {!isLoginPage && <AppMenu/>}
            {!isLoginPage && <SidepanelDeepLinkHost/>}
          </AnimatePresence>
          {location.pathname.startsWith("/warehouse") && <FeedbackWidget />}
        </Box>
      </div>
      <InstallPromptModal
        open={showInstallModal}
        onClose={() => setShowInstallModal(false)}
      />
    </TopbarProvider>
    // </DndProvider>
  );
}

export default App;
